module.exports = __webpack_public_path__ + "static/media/demand.f523f39b.svg";